import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./lib/auth";
import { ClientAuthProvider } from "./lib/clientAuth";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root");

// Both providers wrap the app — they hit different /me endpoints so they
// don't fight each other. The same browser can be both an owner and an
// invited client (rare but possible) without either session blowing the
// other away.
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ClientAuthProvider>
          <App />
        </ClientAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
